import PropTypes from 'prop-types'

import IconLink from 'components/Shared/IconLink/Index'

const EnabledIcon = ({ enabled, onClick, className }) => {
  const iconName = enabled ? 'icon-enabled' : 'icon-disabled'

  return (
    <IconLink
      className={className}
      iconName={iconName}
      onClick={onClick}
      hoverable={!!onClick}
    />
  )
}

EnabledIcon.propTypes = {
  enabled: PropTypes.bool,
  onClick: PropTypes.func,
}

export default EnabledIcon
